import { useEffect } from "react";
import { useTheme } from "../context/ThemeContext";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, user }) => {
  const { darkMode } = useTheme();

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen || !user) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className={`p-8 rounded-xl shadow-2xl w-[32rem] transition-colors ${
          darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          className={`text-2xl text-center font-bold mb-6 ${
            darkMode ? "text-red-400" : "text-red-600"
          }`}
        >
          Sigur doriți să ștergeți?
        </h2>
        <p className="mb-6 text-lg text-center">
          Utilizatorul{" "}
          <span className={`font-bold ${darkMode ? "text-gray-300" : "text-gray-700"}`}>
            {user.name}
          </span>{" "}
          va fi șters definitiv.
        </p>
        <div className="flex justify-between w-full mt-6">
          <button
            onClick={onClose}
            className={`w-full max-w-[150px] h-14 rounded-3xl text-lg font-semibold transition ${
              darkMode
                ? "bg-gray-700 hover:bg-gray-600 text-white"
                : "bg-gray-300 hover:bg-gray-400 text-black"
            }`}
          >
            Anulează
          </button>
          <button
            onClick={() => onConfirm(user.id)}
            className={`w-full max-w-[150px] h-14 rounded-3xl text-lg font-semibold transition ${
              darkMode
                ? "bg-red-700 hover:bg-red-600 text-white"
                : "bg-red-600 hover:bg-red-500 text-white"
            }`}
          >
            Șterge
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
